var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5288_13798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C6.72222 0.5 7.43724 0.642579 8.10449 0.918945C8.77178 1.19535 9.37795 1.60061 9.88867 2.11133C10.3994 2.62205 10.8047 3.22822 11.0811 3.89551C11.3574 4.56276 11.5 5.27778 11.5 6C11.5 6.72223 11.3574 7.43724 11.0811 8.10449C10.8047 8.77178 10.3994 9.37795 9.88867 9.88867C9.37795 10.3994 8.77178 10.8047 8.10449 11.0811C7.43724 11.3574 6.72223 11.5 6 11.5C4.54131 11.5 3.14278 10.9201 2.11133 9.88867C1.07988 8.85722 0.5 7.45869 0.5 6C0.5 4.54131 1.07988 3.14278 2.11133 2.11133C3.14278 1.07988 4.54131 0.5 6 0.5Z",
    fill: "white",
    stroke: "#16BAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89648 5.99805L5.24648 7.34805L8.09648 4.49805",
    stroke: "#16BAB6",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5288_13798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.49ecf64f.svg";
export { ForwardRef as ReactComponent };